/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userCampaignMessages.internal

import features.userCampaignMessages.models.CampaignMessagesModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class CampaignMessagesRequest : NetworkRequest() {

    suspend fun getCampaignMessages(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<CampaignMessagesModel> {
        return safeNetworkCall {
            get(
                endpoint = CampaignMessagesEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
